// removed by extract-text-webpack-plugin
module.exports = {"container":"a8_g"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/OrganiserDetailPage/styles.module.css
// module id = 1350
// module chunks = 27